export const projectsData = [
    {
        id: 1,
        title: "Photographie",
        date: "Septembre 2022",
        languages: ["Canon EOS 450D", "50mm"],
        infos: "Projet de Photographie avec pour thème, le mouvement",
        img: "./assets/img/projet-2.jpg",
        link: "https://www.linkedin.com/posts/clario-cadran-82b20b209_photos-activity-6983418088897548288-i4kZ?utm_source=share&utm_medium=member_desktop",
    },
    {
        id: 2,
        title: "Musée de l'automobile",
        date: "Novembre 2022",
        languages: ["HTML", "CSS"],
        infos: "Refonte du site web du musée de l'automobile de Valencay. Une première semaine dédié a l'UI/UX et une deuxième au développement.",
        img: "./assets/img/projet-1.jpg",
        link: "https://musee-automobile-valencay.netlify.app/",
    },
    {
        id: 3,
        title: "Midjourney on rails",
        date: "Mars 2023",
        languages: ["Ruby on Rails", "MidJourney"],
        infos: "Créer un site web avec Ruby on Rails en utilisant des images générées par l'IA de MidJourney. Notre thème a donc été d'imaginer un monde ou les voitures thermiques n'étaient plus utilisées et se retrouvaient a l'abandon.",
        img: "./assets/img/projet-3.jpg",
        link: "https://car-world.osc-fr1.scalingo.io/",
    },
    {
        id: 4,
        title: "Motion Design",
        date: "Décembre 2022",
        languages: ["After Effects", "Premier Pro"],
        infos: "Illustration de la théorie de Emile Durkheim en Motion Design",
        img: "./assets/img/projet-4.jpg",
        link: "https://www.youtube.com/watch?v=8pITVMSNv_c&ab_channel=YvanANDRIAMIHAJARIVO",
    },
];
